import { IconFont, SvgIcon } from '@/components'
import { useLogout } from '@/pages/login/util'
import { removeToken, setPrivatize, useUserDispatch } from '@/redux/userSlice'
import { setMenuInfo } from '@/redux/menuSlice'
import { Dropdown, Menu, Typography } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import React from 'react'
import { t } from '@/i18n'

// 账号中心菜单项配置（用于传递给 MenuList 组件）
const AccountSubMenuItem = React.forwardRef(
  (props: any, ref) => null, // 这个组件仅用于传递 props，不渲染内容
)

AccountSubMenuItem.displayName = 'AccountSubMenuItem'

export const HeaderRight = ({ userInfo }) => {
  const [myHover, setMyHover] = useState(false)
  const [logout] = useLogout()
  const navigator = useNavigate()
  const userDispatch = useUserDispatch()
  const dispatch = useDispatch()

  const loginoutHandler = async () => {
    await logout({}).catch(_ => {})
    userDispatch(removeToken())
    userDispatch(setPrivatize(false))
  }

  const handleAccountCenter = () => {
    // 分发菜单信息
    dispatch(
      setMenuInfo({
        text: t('账号中心'),
        to: '/account/basic-info',
        subMenuItems: {
          props: {
            children: [
              {
                props: {
                  text: t('基本信息'),
                  to: '/account/basic-info',
                  show: true,
                  level: 1,
                  icon: <SvgIcon width={16} height={16} name={'基本信息'} />,
                },
              },
              {
                props: {
                  text: t('账号安全'),
                  to: '/account/security',
                  show: true,
                  level: 1,
                  icon: <SvgIcon width={16} height={16} name={'账号安全'} />,
                },
              },
            ],
          },
        },
      }),
    )
    navigator('/account/basic-info')
  }

  const menu = (
    <Menu
      items={[
        {
          label: (
            <div className="login-nav" onClick={handleAccountCenter}>
              <Icon type="icon-zizhanghaoguanli" />
              <span style={{ marginLeft: 10 }}>{t('账号中心')}</span>
            </div>
          ),

          key: '0',
        },

        {
          label: (
            <div className="login-nav" onClick={() => loginoutHandler()}>
              <Icon type="icon-tuichudenglu" />
              <span style={{ marginLeft: 10 }}>{t('退出登录')}</span>
            </div>
          ),

          key: '3',
        },
      ]}
    />
  )

  return (
    <HeaderRightContainer>
      <Dropdown overlay={menu} trigger={['click']}>
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onMouseEnter={() => setMyHover(true)}
          onMouseLeave={() => setMyHover(false)}
          className="my-box"
        >
          <LoginoutContainer>
            {myHover ? (
              <SvgIcon width={36} height={36} name="my_hover" />
            ) : (
              <SvgIcon width={36} height={36} name="my_normal" />
            )}
          </LoginoutContainer>
          <Typography.Text ellipsis={{ tooltip: true }} className="email">
            {userInfo?.email}
          </Typography.Text>
        </div>
      </Dropdown>
    </HeaderRightContainer>
  )
}
const LoginoutContainer = styled.div`
  font-size: 20px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: rgb(61, 70, 89);
`
const HeaderRightContainer = styled.div`
  padding-right: 24px;
  display: flex;
  align-items: center;
  ul {
    li.ant-dropdown-menu-item {
      width: 100% !important;
    }
  }
  .my-box {
    .email {
      max-width: 180px;
      font-size: 14px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #d0d0d0;
      line-height: 21px;
      margin-left: 10px;
      &:hover {
        color: #fff;
      }
    }
    &:hover .email {
      color: #fff;
    }
  }

  .login-nav {
    //width: 124px;
    height: 28px;
    border-radius: 6px;
    //background: #fff;
    display: flex;
    align-items: center;
    //padding-left: 16px;
    //&:hover {
    //  background: #ebeef7;
    //}
  }
  .ant-dropdown-menu-item-active {
    background: transparent;
  }
  .ant-dropdown-menu-item,
  //.ant-dropdown-menu-submenu-title {
  //  padding: 5px;
  //}
  .ant-dropdown-menu {
    width: 144px;
    .ant-dropdown-menu-item {
      width: 126px;
      &:nth-child(5) {
        border-top: 1px solid #eaedf1;
      }
    }
  }
`
const Icon = styled(IconFont)`
  font-size: 16px;
`
